import { RectNode, RectNodeModel, h } from '@logicflow/core';
import { drawLabel } from './textUtils';
import { applySimStatusStyle } from './simStatus';
import { getThemeStyle } from '../theme';

class KnowledgeSourceView extends RectNode {
  getShape() {
    const { model } = this.props;
    const { x, y, width, height } = model;
    const style = model.getNodeStyle();
    const label = model.properties?.name || model.text?.value || '';
    const textFill = (model.graphModel?.__epxDmnTheme?.text?.fill) || '#212121';

    const l = x - width / 2;
    const r = x + width / 2;
    const t = y - height / 2;
    const b = y + height / 2;

    const w = width;
    const step = w / 3;
    const amp = 7;

    // Top + right + wavy bottom + left
    const d = `
      M ${l} ${t}
      L ${r} ${t}
      L ${r} ${b - amp}
      Q ${r - step / 2} ${b - amp * 2} ${r - step} ${b - amp}
      T ${r - 2 * step} ${b - amp}
      T ${l} ${b - amp}
      L ${l} ${t}
      Z
    `;

    return h('g', {}, [
      h('path', { d, ...style }),
      drawLabel(h, label, x, y - 2, width - 16, { fill: textFill }),
    ]);
  }

  getText() { return ''; }
}

class KnowledgeSourceModel extends RectNodeModel {
  initNodeData(data) {
    super.initNodeData(data);
    this.width = 100;
    this.height = 63;
    this.text = { ...this.text, editable: true, draggable: false, value: this.text?.value || '' };
  }

  getNodeStyle() {
    const style = super.getNodeStyle();
    const t = getThemeStyle(this.graphModel, 'knowledgeSource');
    style.stroke = t.stroke || '#d48806';
    style.strokeWidth = t.strokeWidth || 2;
    style.fill = t.fill || '#fffbe6';
    return applySimStatusStyle(style, this.properties);
  }
}

export const KnowledgeSource = {
  type: 'dmn:KnowledgeSource',
  view: KnowledgeSourceView,
  model: KnowledgeSourceModel,
};
